import {
  Amex,
  Discover,
  Mastercard,
  MoneygramIcon,
  MoneygramLogo,
  Sepa,
  PAD,
  VisaCard,
} from '@entrata/portals-common/lib/icons/card'
import { UnionPay, ApplePay, Bacs } from 'portal-modules/common/svgs'
import { InstantBankTransfer } from '@entrata/portals-common/lib/icons/line_icons/InstantBankTransfer'
import { PaymentCard } from '@entrata/portals-common/lib/icons'

export default {
  4: PAD,
  5: VisaCard,
  6: Mastercard,
  7: Discover,
  8: Amex,
  10: { icon: MoneygramIcon, logo: MoneygramLogo },
  13: Sepa,
  14: PAD,
  16: InstantBankTransfer,
  17: UnionPay,
  55: ApplePay,
  20: PaymentCard,
  22: Bacs,
}
